import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
    border-radius: 6px;
    overflow: hidden;
    padding: 0;

    .ant-modal-footer {
        padding: 0;
    }

    .ant-modal-title {
        font-weight: 600;
        color: var(--brand-9);
        font-size: 20px;
        line-height: 28px;
    }
`;

export const StyledModalFooter = styled.footer`
    padding: 12px 24px;
`;

export const StyledModalFooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    align-items: center;
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
`;

const iconStyles = {
    error: {
        color: 'var(--dust-red-6)',
        bg: 'var(--dust-red-1)',
    },
    success: {
        color: 'var(--polar-green-6)',
        bg: 'var(--polar-green-1)',
    },
    warning: {
        color: 'var(--orange-6)',
        bg: 'var(--orange-1)',
    },
    default: {
        color: 'var(--brand-6)',
        bg: 'var(--brand-1)',
    },
};

export const StyledIconWrapper = styled.span<{ $type?: 'error' | 'success' | 'warning' | 'default' }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    width: 64px;
    height: 64px;
    font-size: 120px;

    ${({ $type = 'default' }) => {
        const { color, bg } = iconStyles[$type];
        return `
      --local-icon-color: ${color};
      --local-icon-bg: ${bg};
    `;
    }}

    color: var(--local-icon-color);
    background-color: var(--local-icon-bg);
`;
